import React, { useState, createContext, type ReactNode, useContext } from "react"
import { useTranslation } from "react-i18next"

interface ErrorContextData {
  hasError: boolean
  messageError: string
  titleError: string
  setError: (title: string, message: string) => void
  disableError: () => void
}

const ErrorContext = createContext<ErrorContextData | undefined>(undefined)

interface ErrorProviderProps {
  children: ReactNode
}

export const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
  const [hasError, setHasError] = useState(false)

  const [messageError, setMessageError] = useState("")

  const [titleError, setTitleError] = useState("")

  const setError = (title: string, message: string) => {
    setHasError(true)

    setMessageError(message)

    setTitleError(title)
  }

  const disableError = () => {
    setHasError(false)
  }

  return (
    <ErrorContext.Provider value={{ hasError, titleError, messageError, setError, disableError }}>
      {children}
    </ErrorContext.Provider>
  )
}

export const useError = (): ErrorContextData => {
  const { t } = useTranslation("general")

  const context = useContext(ErrorContext)

  if (!context) {
    throw new Error(t("label_title_erro"))
  }

  return context
}

export {}
